import { render, staticRenderFns } from "./ChatPanel.vue?vue&type=template&id=4b7034fa&scoped=true"
import script from "./ChatPanel.vue?vue&type=script&lang=js"
export * from "./ChatPanel.vue?vue&type=script&lang=js"
import style0 from "./ChatPanel.vue?vue&type=style&index=0&id=4b7034fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7034fa",
  null
  
)

export default component.exports